import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useBootstrap } from '@/hooks/useBootstrap'
import type { PlanFeature } from '@/types/api'

/**
 * Obsahuje balíček školy funkciu?
 *
 * Rozhoduje server (`apps.tenants.features`) - modul mimo balíčka sa
 * nedá zapnúť a zapnutý nefunguje. Tu sa len zamkne prepínač. Kým bootstrap
 * nie je načítaný (alebo ho starý server nemá), nič sa nezamyká.
 */
export function usePlanFeature(feature: PlanFeature) {
  const { data } = useBootstrap()
  return {
    allowed: data?.plan?.features?.[feature] ?? true,
    from: data?.plan?.feature_from?.[feature] ?? 'Profi',
  }
}

/** Riadok pod zamknutým prepínačom - od ktorého balíčka a kde ho objednať. */
export function PlanLock({ feature, text }: { feature: PlanFeature; text?: string }) {
  const { t } = useTranslation()
  const { allowed, from } = usePlanFeature(feature)
  if (allowed) return null

  return (
    <p className="flex flex-wrap items-center gap-1 text-xs text-slate-500">
      <Lock size={12} className="shrink-0" />
      {text ?? t('billing.feature.locked', { plan: from })}{' '}
      <Link to="/settings/subscription#plan" className="text-action-600 hover:underline">
        {t('billing.feature.upgrade')}
      </Link>
    </p>
  )
}
